<template>
  <Frame>
    <PageHeader :title="$t('comm.productPicture')" :hasBack="false"/>
    <div class="list-contain">
      <div class="head-contain">

        <div class="filter-contain">
          <span>ItemCode：</span>
          <el-input v-model="materialId" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
        </div>

        <div class="filter-contain">
          <span>ItemName：</span>
          <el-input v-model="materialName" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
        </div>

        <div class="filter-contain">
          <span>{{ $t('productPicture.materialSpec') }}：</span>
          <el-input v-model="materialSpec" :placeholder="$t('salSalesOrder.inputpls')" size="small" clearable></el-input>
        </div>

        <div style="width: 24%;">
          <span style="width: 100%;display: flex; justify-content: flex-end;">
            <el-button type="reset" @click="reset()">{{ $t('button.reset') }}</el-button>
            <el-button type="primary" @click="GetListData(0)">{{ $t('button.query') }}</el-button>
          </span>
        </div>
      </div>
    </div>
    <el-table ref="multipleTable" :data="tableData" :height="tableHeight" style="margin:0;width:100%" v-loading="tableLoading">
      <el-table-column :width="WidthControl('X_BPMaterialId',tableData)" prop="X_BPMaterialId" label="ItemCode"></el-table-column>
      <el-table-column :min-width="WidthControl('X_BPMaterialName',tableData)" prop="X_BPMaterialName" label="ItemName"></el-table-column>
      <el-table-column :min-width="WidthControl('X_BPMaterialSpec',tableData)" prop="X_BPMaterialSpec" show-overflow-tooltip :label="$t('productPicture.materialSpec')"></el-table-column>
      <el-table-column :width="WidthControl('BizPartnerId',tableData)" prop="BizPartnerId" :label="$t('productPicture.supplier')"></el-table-column>
      <el-table-column width="160"  prop="pic1" :label="$t('productPicture.pic1')">
        <template slot-scope="scope">
            <img class="backgroundimg" :src='development+scope.row.pic1' @click="createImg(scope.row.AccessoryId1)"/>
        </template>
      </el-table-column>
      <el-table-column width="160" prop="pic2" :label="$t('productPicture.pic2')">
        <template slot-scope="scope">
            <img class="backgroundimg" :src='development+scope.row.pic2' @click="createImg(scope.row.AccessoryId2)"/>
        </template>
      </el-table-column>
      <el-table-column width="160" prop="pic3" :label="$t('productPicture.pic3')">
        <template slot-scope="scope">
            <img class="backgroundimg" :src='development+scope.row.pic3' @click="createImg(scope.row.AccessoryId3)" />
        </template>
      </el-table-column>
    </el-table>
    <div class="footer-contain">
      <PageSizeChanger :pagesize="pageSize" :afterChange="pageSizeChange"></PageSizeChanger>
      <el-pagination ref="pagination" class="pagination" @current-change="handleCurrentChange" layout="total,prev,pager,next,jumper" :pager-count="pagecount" :current-page="currentPage" :total="totalCount" :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog width="50%" :title="$t('comm.preview')" :visible.sync="previsible" :append-to-body="true">
      <img class="backgroundimg" :src='preUrl' />
    </el-dialog>
  </Frame>
</template>
<script>
import { listMixin } from '@/agency/mixin/mixin.js'
export default {
  name: "ProductPicture",
  mixins: [listMixin],
  data() {
    return {
      materialId: "", //过滤条件
      materialName: "",
      materialSpec: "",
      tableData: [], //当前页数据
      pageIndex: 0,
      totalCount: 0,
      tableLoading: false,
      resizeFlag: null,
      tableHeight: window.innerHeight - 280,
      pagecount: 5,
      previsible:false,
      preUrl:'',
    };
  },
  props: {
    GetListData: {
      type: Function,
      default: function(pageIndex, ...arg) {
        this.getListData(pageIndex, ...arg);
      }
    }
  },
  mounted() {
    this.frameOnResize(280);
  },
  created() {
    //this.GetListData(this.pageIndex);
  },
  methods: {
    createImg(picId){
      var src='/AgencyComm/Images/wutu.png';
      if (picId && picId!="") src = '/AgencyComm/Handler/AccessoryHandler.ashx?action=download&accessoryId=' + picId;
      this.preUrl=this.development+src;
      this.previsible=true;
    },
    getImgUrl(path){
      return this.axios.post(path);
    },
    getListData(index) {
      this.pageIndex = index;
      var ymAy = new Array();
      ymAy.push(this.setAyList("A.X_BPMaterialId", this.materialId));
      ymAy.push(this.setAyList("A.X_BPMaterialName", this.materialName));
      ymAy.push(this.setAyList("A.X_BPMaterialSpec", this.materialSpec));
      this.tableLoading = true;
      this.axiosInvoke(this.YMBillHandlerUrl,{
          action: "getproductpicture",
          ymAy: JSON.stringify(ymAy),
          pageIndex: this.pageIndex+1,
          pageSize: this.$store.state.pagesize
        },(res) => {
          const data = res.data;
          this.tableLoading = false;
          this.tableData = data.DataTable ? data.DataTable : [];
          this.totalCount = data.totalCount;
          if(data.state!= 1){
            this.$alert(data.message, this.$t("comm.tip"));
            return;
          }
        },false,true);
    }, //根据下拉框信息组合数组
    setAyList(fieldName, fieldNameVal) {
      var tempAy = new Array();
      var fieldNameAttr=0;
      //获取下拉框选中的值
      if(fieldNameVal!="") fieldNameAttr = 2;
      //将3个参数添加到数组
      tempAy.push([
        { name: fieldName },
        { code: fieldNameAttr },
        { value: fieldNameVal }
     ]);
     return tempAy[0];
    },
    handleCurrentChange(page) {
      this.pageIndex = page - 1;
      this.GetListData(this.pageIndex);
    },
    pageSizeChange() {
      this.GetListData(0);
    },
    reset() {
      this.materialId = "";
      this.materialName = "";
      this.materialSpec = "";
      this.tableData = [];
      this.pageIndex = 0;
      this.totalCount = 0;
    },
  }
};
</script>
<style scoped>
.list-contain {
  display: flex;
  padding: 20px 0px;
}
.head-contain {
  padding: 0 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.filter-contain {
  width: 24%;
  padding-right: 1%;
  display: flex;
  flex-wrap: nowrap; 
}
.filter-contain > span {
  color: black;
  font-size: 14px;
  margin: auto;
  white-space: nowrap;
}
.head-contain > div >span > .el-button{
  padding: 10px 18px;
}

.el-input {
  padding-left: 5px;
}
.el-table /deep/ .el-table__header .cell .el-checkbox:first-child {
  padding-left: 5px;
}
.footer-contain {
  display: flex;
  padding-top: 6px;
  justify-content: center;
}
.pagination {
  padding-top: 4px;
}
.el-table /deep/ th.el-table__cell {
  background-color: #f9f9f9;
}
.el-table /deep/ thead {
  font-size: 14px;
  color: black;
}
.el-dialog__wrapper /deep/ .el-dialog .el-dialog__body{
  text-align: center;
}
.el-dialog__wrapper /deep/ .el-dialog .el-dialog__body img{
  width: 100%;
}
.el-table{
  font-size: 12px;
  color: black;
}
.el-table .cell img{
  width: 60px;
  height: 60px;
}
</style>
